console.log("Load: application.js");

// Entry point for the Rails application using ESBuild
import "@hotwired/turbo-rails";
import * as bootstrap from "bootstrap"
import "trix"
import "@rails/actiontext"

import { Application } from "@hotwired/stimulus";
const application = Application.start();
window.Stimulus = application;

import ClientSortController from "./controllers/client_sort_controller"
application.register("client-sort", ClientSortController)

import "./add_jquery";  // ← must be first
import "jquery-ui";

// TODO: DEPRECATE DATATABLES
import DataTable from "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-searchpanes-bs5";
import "datatables.net-select-bs5";
import 'datatables.net-scroller-bs5';
import "./datatables/initialize_tables";

import "./spurimpact/alerts";
import "./spurimpact/tom_select";
import "./spurimpact/sortable";
import "./spurimpact/iframeResizer.contentWindow.min";
import "./spurimpact/recaptcha_load";
import "./spurimpact/recaptcha";
import "./spurimpact/file_uploads";
import "./spurimpact/password_toggle";
import "./spurimpact/globals";
import "./spurimpact/user";
import "./spurimpact/category_restrictions_select";
import "./spurimpact/toggle_target";

import "./addresses/google_places";
import "./addresses/country_state_toggle";
import "./maps/donor_map";
import "./maps/de_donor_map";

import "./events/total_raised_countdown";
import "./events/domains";

import "./donations/finalize_transaction";
import "./registrations/form_actions.js"

import "./fundraisers/search";
import "./fundraisers/custom_question_option_fields";
import "./fundraisers/embed_preview"
import "./fundraisers/copy_previous"

import "./organizations/copy_address_fields";
import "./organizations/required_document_fields";

// import "./spurimpact/form_actions"; DEPRECATE
// import "./embeds/fundraiser_preview"; DEPRECATE

// use only to create new merged geojson map
// - comment out de_donor_map (above ^^)
// - uncomment create_de_donor_map
// import "./maps/create_de_donor_map";

// masked URL helper
document.addEventListener("turbo:load", () => {
  // clean up url when class exists
  if (document.querySelector(".clean_url") && window.history.replaceState) {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
  }
})

// image upload validations
window.validateImageFileInput = function (input, filenameFieldId) {
  const file = input.files && input.files[0];
  if (!file) return;

  const maxSize = 5 * 1024 * 1024; // 5 MB
  const validTypes = ["image/jpeg", "image/png", "image/svg+xml", "image/tiff"];
  const validExts  = ["jpg","jpeg","png","svg","tif","tiff"];
  const ext = (file.name.split(".").pop() || "").toLowerCase();
  const typeOk = (file.type && validTypes.includes(file.type)) || validExts.includes(ext);

  const filenameField = document.getElementById(filenameFieldId);

  if (!typeOk) {
    alert("Invalid file type. Please upload a JPG, PNG, SVG, or TIFF image.");
    input.value = "";
    if (filenameField) filenameField.value = "";
    return;
  }

  if (file.size > maxSize) {
    alert("The image file is too large. Maximum allowed size is 5 MB.");
    input.value = "";
    if (filenameField) filenameField.value = "";
    return;
  }

  if (filenameField) filenameField.value = file.name;
};

// alerts
function fadeOutAndHide(element, options = {}) {
  const delay = options.delay ?? 4000;
  const duration = options.duration ?? 400;

  // Cancel any existing timers on this element
  const existingTimer = element.data("fadeTimer");
  if (existingTimer) {
    clearTimeout(existingTimer);
    element.removeData("fadeTimer");
  }

  const timer = setTimeout(() => {
    element.slideUp(duration, () => {
      element.addClass("d-none");
    });
  }, delay);

  // Store timer reference on the element
  element.data("fadeTimer", timer);
}

// for auth_modal
document.addEventListener("turbo:load", () => {
  const modalElement = document.getElementById("auth-modal");
  if (!modalElement) return; // no modal = user is already logged in

  // Initialize modal with static backdrop and no keyboard dismissal
  const modal = new bootstrap.Modal(modalElement, {
    backdrop: "static",
    keyboard: false
  });

  modal.show();

  // Disable the underlying organization form while the modal is active
  const orgForm = document.querySelector("form#new_organization");
  if (orgForm) {
    orgForm.querySelectorAll("input, select, textarea, button").forEach(el => {
      el.disabled = true;
    });
  }
});

//////////////////////
// Sessions
document.addEventListener("turbo:load", function () {
  function password_toggle(){
    const toggle = document.getElementById("toggle-password");
    const icon = document.getElementById("toggle-password-icon");
    const input = document.getElementById("password-input");
    if (!toggle || !icon || !input) return;

    toggle.addEventListener("click", function () {
      const isPassword = input.type === "password";
      input.type = isPassword ? "text" : "password";
      icon.classList.toggle("bi-eye");
      icon.classList.toggle("bi-eye-slash");
    });
  }

  password_toggle();
});

////////////////////////////////////
// categories
document.addEventListener("turbo:load", function() {
  function orgCategoryTypeSelect() {
    const cards = document.querySelectorAll(".org-category-type-card");
    if (cards.length === 0) return;

    cards.forEach((card) => {
      const selectAllBtn = card.querySelector(".select-all");
      const deselectAllBtn = card.querySelector(".deselect-all");
      const checkboxes = card.querySelectorAll(".checkbox-group input[type='checkbox']");

      if (selectAllBtn) {
        selectAllBtn.addEventListener("click", () => {
          checkboxes.forEach((cb) => (cb.checked = true));
        });
      }

      if (deselectAllBtn) {
        deselectAllBtn.addEventListener("click", () => {
          checkboxes.forEach((cb) => (cb.checked = false));
        });
      }
    });
  }

  orgCategoryTypeSelect();
});

////////////////////////////////////
// print donation receipts - move to spurimpact/print_donation_receipts.js
document.addEventListener("turbo:load", () => {
  const btn = document.getElementById("print-receipt-btn");
  if (!btn) return;

  btn.addEventListener("click", (e) => {
    e.preventDefault();

    const printArea = document.getElementById("print-area");
    if (!printArea) {
      alert("Print area not found");
      return;
    }

    const printWindow = window.open("", "_blank", "width=650,height=900");
    if (!printWindow) return;

    const styles = Array.from(
      document.querySelectorAll("link[rel='stylesheet']")
    )
      .map(link => link.cloneNode(true))
      .map(link => link.outerHTML)
      .join("");

    const eventName = printArea.dataset.event_name || "Receipt";
    const baseHref = document.location.origin;

    // Build full document using DOM APIs
    const doc = printWindow.document;
    doc.open();

    const html = doc.createElement("html");
    const head = doc.createElement("head");
    const base = doc.createElement("base");
    base.href = `${baseHref}/`;

    const title = doc.createElement("title");
    title.textContent = `${eventName} Transaction Receipt`;

    const styleBlock = doc.createElement("style");
    styleBlock.textContent = `
      @page { margin: 0.5in; }

      html, body {
        margin: 0;
        padding: 20px 60px;
        background: white;
      }

      .card {
        box-shadow: none !important;
      }
    `;

    head.appendChild(base);
    head.appendChild(title);

    // Inject existing stylesheets
    const temp = doc.createElement("div");
    temp.innerHTML = styles;
    Array.from(temp.children).forEach(el => head.appendChild(el));

    head.appendChild(styleBlock);

    const body = doc.createElement("body");
    body.innerHTML = printArea.outerHTML;

    html.appendChild(head);
    html.appendChild(body);
    doc.appendChild(html);
    doc.close();

    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  });
});